// extracted by mini-css-extract-plugin
export default {"main":"allNGOS_main__y-q3v","headline":"allNGOS_headline__Gz9ly"};